module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof53"
    }
  }, [_c('p', {
    staticClass: "para2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Order of St. John of Jerusalem")]), _vm._v(" was created by Emperor Paul in 1798 after he became the protector of the Order of Malta in 1797, and the Grand Master of the Order in 1798. Paul established two types of the award: Commanders of the Cross of St. John of Jerusalem for Catholic and Orthodox Christians, and Honorary Commanders and Chevaliers of Order. In 1800, he also created a special medal ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("donat")]), _vm._v(") of the Order for lower officer ranks. The Order lost its function after Paul’s death in 1801.")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Color of Ribbon:")]), _vm._v(" Black (no image)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d35a85da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof53.vue
// module id = 288
// module chunks = 0